import React from "react";
import { ICardElementWithChildren } from "backend/model/model";
import DrillDownModal from "./DrillDownModal";
import DrillDownTable from "../tables/DrillDownTable";
import useLink from "@qpr/client-api-base/hooks/useLink";
import typeToView from "routing/typetoview";
import { IChartSelectEvent } from "../charts/types";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import flattenHierarchy from "backend/flattenHierarchy";

const useStyle = makeThemedStyles("KPIDrillDown", (theme) => ({
  title: {
    display: "flex",
    fontWeight: 500,
    fontSize: "15px",
    color: "white",
    marginBottom: "10px",
    marginTop: "10px",
  },
}));

const KPIDrillDown = (
  props: React.PropsWithChildren<{
    title: string;
    items: ICardElementWithChildren[];
    onClose?: () => void;
    showModal?: IChartSelectEvent | null;
  }>
) => {
  const classes = useStyle();
  const { showModal, onClose } = props;

  const activeItems = React.useMemo(() => {
    return showModal
      ? showModal.items
          .filter((el) => el.typename === "KPI")
          .filter((el) =>
            showModal?.name === "No Value"
              ? !el.rangevalue
              : el.rangename === showModal?.name
          )
      : [];
  }, [props.items, props.showModal, props.showModal?.items]);

  const pickBgColor = React.useMemo(() => {
    console.log("pickBgColor", activeItems, showModal);
    if (activeItems.length === 0) return "rgba(255,255,255,0.7)";
    const [el] = activeItems;
    return `#${el.rangecolor || "000000"}80`;
  }, [activeItems]);

  const link = useLink();

  const rowClick = React.useCallback((el: ICardElementWithChildren) => {
    link({ meaId: el.id, page: typeToView(el.typename) });
  }, []);

  return (
    <DrillDownModal isOpen={!!showModal} onClose={onClose}>
      <div
        style={{
          background: pickBgColor,
          width: "100%",
          color: "black",
          padding: "30px",
        }}
      >
        <div className={classes.title}>{props.title}</div>
        <DrillDownTable
          width="610px"
          maxHeight="300px"
          columns={[
            {
              title: "KPI",
              value: (el) => <div>{el.elem.name}</div>,
              onRowClick: rowClick,
            },
            {
              title: "Actual (YTD)",
              value: (el) => <div>{el.elem.ACT_YTD_prettyvalue}</div>,
              onRowClick: rowClick,
            },
            {
              title: "Target (YTD)",
              value: (el) => <div>{el.elem.TAR_YTD_prettyvalue}</div>,
              onRowClick: rowClick,
            },
            {
              title: "Score (YTD)",
              value: (el) => <div>{el.elem.PERF_YTD_prettyvalue}</div>,
              onRowClick: rowClick,
            },
          ]}
          items={activeItems}
        />
      </div>
    </DrillDownModal>
  );
};

export default KPIDrillDown;
